const SITE_KEY = process.env.REACT_APP_RECAPTCHA_SITE_KEY || '';
const SCRIPT_SELECTOR = 'script[data-recaptcha="v2"]';

export const getRecaptchaSiteKey = () => SITE_KEY;

const waitForGrecaptcha = () =>
  new Promise((resolve, reject) => {
    if (window.grecaptcha?.render) {
      resolve();
      return;
    }

    const startedAt = Date.now();
    const interval = setInterval(() => {
      if (window.grecaptcha?.render) {
        clearInterval(interval);
        resolve();
      } else if (Date.now() - startedAt > 10000) {
        clearInterval(interval);
        reject(new Error('reCAPTCHA failed to initialize'));
      }
    }, 50);
  });

export const loadRecaptchaScript = () => {
  if (!SITE_KEY) {
    return Promise.resolve(false);
  }

  if (window.grecaptcha?.render) {
    return Promise.resolve(true);
  }

  return new Promise((resolve, reject) => {
    const existing = document.querySelector(SCRIPT_SELECTOR);
    if (existing) {
      waitForGrecaptcha().then(() => resolve(true)).catch(reject);
      return;
    }

    const script = document.createElement('script');
    script.src = 'https://www.google.com/recaptcha/api.js?render=explicit';
    script.async = true;
    script.defer = true;
    script.dataset.recaptcha = 'v2';
    script.onload = () => {
      waitForGrecaptcha().then(() => resolve(true)).catch(reject);
    };
    script.onerror = () => reject(new Error('Failed to load reCAPTCHA'));
    document.head.appendChild(script);
  });
};

export const renderRecaptchaWidget = (container) => {
  if (!SITE_KEY || !container || !window.grecaptcha?.render) {
    return null;
  }

  if (container.dataset.widgetId) {
    return Number(container.dataset.widgetId);
  }

  const widgetId = window.grecaptcha.render(container, {
    sitekey: SITE_KEY,
    theme: 'light',
    size: 'normal'
  });
  container.dataset.widgetId = String(widgetId);
  return widgetId;
};

export const getRecaptchaResponse = (widgetId) => {
  if (widgetId === null || widgetId === undefined || !window.grecaptcha?.getResponse) {
    return '';
  }
  return window.grecaptcha.getResponse(widgetId);
};

export const resetRecaptchaWidget = (widgetId) => {
  if (widgetId === null || widgetId === undefined || !window.grecaptcha?.reset) {
    return;
  }
  window.grecaptcha.reset(widgetId);
};
